export default __webpack_public_path__ + "images/0adc86a8a0d8c7bcd4f21c68060cb02d-fallevents.webp";